<template>
    <div :id="'radio--' + component_id">
        <div v-if="options_loaded && passed_filter">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>Opening Direction: <br> <small>(viewed from outside)</small></span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Opening Direction:';
                }
            },
            component_id: {
                default(){
                    return 'opening_direction';
                }
            },
            securedByDesign: {
                default(){
                    return '1';
                }
            },
            frameCombination: {
                default(){
                    return '';
                }
            },
            typeRange: {
                default(){
                    return '';
                }
            }
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.securedByDesign, this.frameCombination, this.typeRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/opening-direction?secured_by_design=' + this.securedByDesign + '&frame_combination=' + this.frameCombination + '&type_range=' + this.typeRange;
            },
            cache_key(){
                return '_' + this.securedByDesign + '_' + this.frameCombination + '_' + this.typeRange;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
